import respond from './utilities/respond'
import at from '../../actionTypes'
import generateActionCreators from './utilities/generateActionCreators'

const brandActions = {
	brandFetchBegin: brandKey => respond(at.BRAND_FETCH_BEGIN, { brandKey }),
	brandFetchSuccess: brand => respond(at.BRAND_FETCH_SUCCESS, { brand }),
	brandFetchFail: (brandKey, ...rest) => respond(at.BRAND_FETCH_FAIL, { brandKey, ...rest }),
	...generateActionCreators(at.brandSuggestions, 'brandSuggestions')
}

export default brandActions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/brandActions.js